"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPutRecordDataResponse = void 0;

var _utils = require("../../../utils");

var createPutRecordDataResponse = function createPutRecordDataResponse(inputData) {
  return function (raw) {
    return (0, _utils.parseModel)(raw, {
      result: {
        path: 'PutRecordDataResult[0]',
        model: _utils.genericAsResultHeader
      },
      response: function response(raw) {
        var resultId = Number(raw.Id[0]); // If updating an existing record the result id should match the input id

        if (inputData.hasOwnProperty('id') && inputData.id !== resultId) {
          throw new Error('');
        } else {
          // if creating a new record update the input with the returned Id
          inputData.id = resultId;
        }

        return inputData;
      }
    });
  };
};

exports.createPutRecordDataResponse = createPutRecordDataResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/user/response-parsers/put-record-data.js
// module id = 242
// module chunks = 0